// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Preset: Midnight Blue — cool dark blue palette */
.vnsc-root[data-chart-theme="midnight-blue"] {
  --vnsc-bg-primary: #0d1117;
  --vnsc-bg-secondary: #161b22;
  --vnsc-bg-tertiary: #0d1117;
  --vnsc-bg-elevated: #1c2333;
  --vnsc-bg-overlay: rgba(13, 17, 23, 0.9);
  --vnsc-bg-modal: #161b22;
  --vnsc-bg-popover: #161b22;
  --vnsc-bg-tooltip: #1c2333;
  --vnsc-bg-input: #0d1117;
  --vnsc-bg-input-hover: #161b22;
  --vnsc-bg-hover: rgba(88, 166, 255, 0.08);
  --vnsc-bg-active: rgba(88, 166, 255, 0.14);
  --vnsc-bg-selected: rgba(88, 166, 255, 0.2);
  --vnsc-bg-focus: rgba(88, 166, 255, 0.25);

  --vnsc-text-primary: #c9d1d9;
  --vnsc-text-secondary: #8b949e;
  --vnsc-text-tertiary: #484f58;
  --vnsc-text-link: #58a6ff;
  --vnsc-text-link-hover: #79c0ff;

  --vnsc-border-primary: #21262d;
  --vnsc-border-secondary: #30363d;
  --vnsc-border-divider: #21262d;

  --vnsc-color-primary: #58a6ff;
  --vnsc-color-primary-hover: #79c0ff;
  --vnsc-color-primary-active: #79c0ff;

  --vnsc-color-accent: #58a6ff;
  --vnsc-color-accent-hover: #79c0ff;

  --vnsc-color-grid: rgba(255, 255, 255, 0.07);
  --vnsc-color-grid-subtle: rgba(255, 255, 255, 0.03);
  --vnsc-color-crosshair: #58a6ff;
  --vnsc-color-selection: rgba(88, 166, 255, 0.2);

  --vnsc-scrollbar-thumb: #30363d;
  --vnsc-scrollbar-thumb-hover: #484f58;
}
`, "",{"version":3,"sources":["webpack://./src/widget/styles/tokens/presets/midnight-blue.css"],"names":[],"mappings":"AAAA,mDAAmD;AACnD;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,2BAA2B;EAC3B,2BAA2B;EAC3B,wCAAwC;EACxC,wBAAwB;EACxB,0BAA0B;EAC1B,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;EACzC,0CAA0C;EAC1C,2CAA2C;EAC3C,yCAAyC;;EAEzC,4BAA4B;EAC5B,8BAA8B;EAC9B,6BAA6B;EAC7B,yBAAyB;EACzB,+BAA+B;;EAE/B,8BAA8B;EAC9B,gCAAgC;EAChC,8BAA8B;;EAE9B,6BAA6B;EAC7B,mCAAmC;EACnC,oCAAoC;;EAEpC,4BAA4B;EAC5B,kCAAkC;;EAElC,4CAA4C;EAC5C,mDAAmD;EACnD,+BAA+B;EAC/B,+CAA+C;;EAE/C,+BAA+B;EAC/B,qCAAqC;AACvC","sourcesContent":["/* Preset: Midnight Blue — cool dark blue palette */\r\n.vnsc-root[data-chart-theme=\"midnight-blue\"] {\r\n  --vnsc-bg-primary: #0d1117;\r\n  --vnsc-bg-secondary: #161b22;\r\n  --vnsc-bg-tertiary: #0d1117;\r\n  --vnsc-bg-elevated: #1c2333;\r\n  --vnsc-bg-overlay: rgba(13, 17, 23, 0.9);\r\n  --vnsc-bg-modal: #161b22;\r\n  --vnsc-bg-popover: #161b22;\r\n  --vnsc-bg-tooltip: #1c2333;\r\n  --vnsc-bg-input: #0d1117;\r\n  --vnsc-bg-input-hover: #161b22;\r\n  --vnsc-bg-hover: rgba(88, 166, 255, 0.08);\r\n  --vnsc-bg-active: rgba(88, 166, 255, 0.14);\r\n  --vnsc-bg-selected: rgba(88, 166, 255, 0.2);\r\n  --vnsc-bg-focus: rgba(88, 166, 255, 0.25);\r\n\r\n  --vnsc-text-primary: #c9d1d9;\r\n  --vnsc-text-secondary: #8b949e;\r\n  --vnsc-text-tertiary: #484f58;\r\n  --vnsc-text-link: #58a6ff;\r\n  --vnsc-text-link-hover: #79c0ff;\r\n\r\n  --vnsc-border-primary: #21262d;\r\n  --vnsc-border-secondary: #30363d;\r\n  --vnsc-border-divider: #21262d;\r\n\r\n  --vnsc-color-primary: #58a6ff;\r\n  --vnsc-color-primary-hover: #79c0ff;\r\n  --vnsc-color-primary-active: #79c0ff;\r\n\r\n  --vnsc-color-accent: #58a6ff;\r\n  --vnsc-color-accent-hover: #79c0ff;\r\n\r\n  --vnsc-color-grid: rgba(255, 255, 255, 0.07);\r\n  --vnsc-color-grid-subtle: rgba(255, 255, 255, 0.03);\r\n  --vnsc-color-crosshair: #58a6ff;\r\n  --vnsc-color-selection: rgba(88, 166, 255, 0.2);\r\n\r\n  --vnsc-scrollbar-thumb: #30363d;\r\n  --vnsc-scrollbar-thumb-hover: #484f58;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
